import * as Sentry from '@sentry/react';
import axios from 'axios';
import { useAuth } from '../providers';

import { AuthName, STATUS_CODE_401 } from '../states/constants';

export enum RequestMethods {
  post = 'post',
  get = 'get',
}

export type RequestData = {
  [key: string]: string | boolean;
};

export type RequestOptions = {
  method: RequestMethods;
  data?: unknown;
  headers?: {
    [key: string]: string | boolean | undefined;
  };
};

export function useRequest(baseUrl?: string) {
  const { logout, handleRefreshToken } = useAuth();

  const request = (url: string, options: RequestOptions) =>
    axios({
      method: options.method,
      url: `${baseUrl}${url}`,
      data: options.data,
      headers: {
        ...options.headers,
        Authorization: `Bearer ${localStorage.getItem(AuthName.token)}`,
      },
    })
      .then((response) => response.data)
      .catch(async (error) => {
        Sentry.captureException(error, {
          extra: { operation: 'request', url, options },
        });
        if (error.response.status === STATUS_CODE_401) {
          return handleRefreshToken()
            .catch(() => {
              logout();
            })
            .then(async () => {
              const config = error.config;
              config.headers['Authorization'] = `Bearer ${localStorage.getItem(
                AuthName.token
              )}`;
              return axios.request(config).then((response) => response.data);
            });
        } else {
          throw new Error(error);
        }
      });

  return {
    request,
  };
}
